import { normalizeUiLang, SUPPORTED_UI_LANGS, type UiLang } from "site/services/i18n";

export type BookTitleSource = {
  title?: string | null;
  title_ru?: string | null;
  title_en?: string | null;
  title_fr?: string | null;
};

export type BookTitleData = BookTitleSource;

function bookTitleForLang(source: BookTitleSource | null | undefined, lang: UiLang): string {
  if (!source) {
    return "";
  }
  if (lang === "ru") {
    return String(source.title_ru ?? source.title ?? "").trim();
  }
  if (lang === "en") {
    return String(source.title_en ?? "").trim();
  }
  return String(source.title_fr ?? "").trim();
}

export function pickBookTitle(
  source: BookTitleSource | null | undefined,
  lang: string | null | undefined,
  fallbackLang: UiLang = "ru",
): string {
  if (!source) {
    return "";
  }
  const uiLang = normalizeUiLang(String(lang ?? fallbackLang));
  const picked = bookTitleForLang(source, uiLang);
  if (picked) {
    return picked;
  }
  if (uiLang !== fallbackLang) {
    const fallback = bookTitleForLang(source, fallbackLang);
    if (fallback) {
      return fallback;
    }
  }
  for (const code of SUPPORTED_UI_LANGS) {
    const text = bookTitleForLang(source, code);
    if (text) {
      return text;
    }
  }
  return "";
}

export function bookTitleSourceFromData(data: BookTitleData | null | undefined): BookTitleSource | null {
  if (!data) {
    return null;
  }
  return {
    title: data.title,
    title_ru: data.title_ru,
    title_en: data.title_en,
    title_fr: data.title_fr,
  };
}
